/** @format */

import { Row, Col, Dropdown, Menu } from "antd";
import React from "react";
import { Routes } from "../../utils/Routes";
import { UILink } from "../../components/ui/Link";
import { EditOutlined, MoreOutlined } from "@ant-design/icons";
import { useHistory } from "react-router";
import { UIText } from "../../components/ui/Text";
import { BaseColor } from "../../theme/maps/Colors";
import { useSelector } from "react-redux";
import { selectorPermissionList } from "../../redux-modules/selectors/selectorsPermissions";
import { hasPermission } from "../../utils/permissions/hasPermission";

export const locationListColumns = [
  {
    title: "Nome",
    dataIndex: "name",
    key: "name",
    showMobile: true,
  },
  {
    title: "Località",
    dataIndex: "location",
    key: "location",
    showMobile: false,
  },
  {
    title: "Azioni",
    dataIndex: "actions",
    key: "actions",
    showMobile: true,
    //@ts-ignore
    // eslint-disable-next-line react/display-name
    render: (text, row, index): JSX.Element => (
      <ActionDropdown text={text} row={row} index={index} />
    ),
  },
];

//@ts-ignore
const ActionDropdown = ({ text, row, index }): JSX.Element => {
  const history = useHistory();
  const permissionList = useSelector(selectorPermissionList);

  const menu = (
    <Menu>
      <Menu.Item
        key="1"
        onClick={() => history.push(Routes.locationsEdit.replace(":id_location", row.id))}
        icon={<EditOutlined />}
      >
        Gestisci
      </Menu.Item>
    </Menu>
  );

  if (!hasPermission(permissionList, "Office", "Update")) return <></>;

  return (
    <>
      <Dropdown overlay={menu}>
        <UIText css={"font-size: 24px; cursor: pointer;"} color={BaseColor}>
          <MoreOutlined />
        </UIText>
      </Dropdown>
    </>
  );
};
/*
//@ts-ignore
const ActionDropdown = ({ text, row, index }): JSX.Element => (
  <Row gutter={[12, 0]}>
    <Col>
      <UILink route={Routes.locationsEdit.replace(":id_location", row.id)} label={"Gestisci"} />
    </Col>
  </Row>
);
*/
